import React from 'react';
import { Plus, Trash2, ChevronDown, ChevronUp } from 'lucide-react';
import { FieldLabel } from './FieldLabel';
import { templateFor } from './_editor_helpers';

// Rendering of a single array, delegating each item to FieldRenderer (passed via prop).
export default function ArrayField({ k, value, onChange, Renderer }) {
  const v = Array.isArray(value) ? value : [];
  const update = (i, nv) => {
    const next = v.slice();
    next[i] = nv;
    onChange(next);
  };
  const remove = (i) => onChange(v.filter((_, j) => j !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= v.length) return;
    const next = v.slice();
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  const add = () => onChange([...v, templateFor(v[0] ?? '')]);

  return (
    <div className="space-y-3" data-testid={`array-${k}`}>
      <FieldLabel k={k}>{k}</FieldLabel>
      {v.map((item, i) => (
        <div key={i} className="bg-bg border border-line rounded-md p-4 relative">
          <div className="flex items-center justify-between mb-3">
            <span className="text-eyebrow text-ink-muted">#{i + 1}</span>
            <div className="flex gap-1">
              <button type="button" onClick={() => move(i, -1)} className="p-1.5 text-ink-muted hover:text-ink" data-testid={`array-${k}-up-${i}`}><ChevronUp size={14} /></button>
              <button type="button" onClick={() => move(i, 1)}  className="p-1.5 text-ink-muted hover:text-ink" data-testid={`array-${k}-down-${i}`}><ChevronDown size={14} /></button>
              <button type="button" onClick={() => remove(i)}    className="p-1.5 text-ink-muted hover:text-danger" data-testid={`array-${k}-remove-${i}`}><Trash2 size={14} /></button>
            </div>
          </div>
          <Renderer k={`${k}_${i}`} value={item} onChange={(nv) => update(i, nv)} />
        </div>
      ))}
      <button
        type="button"
        onClick={add}
        className="flex items-center gap-2 px-4 py-2 text-xs font-mono uppercase tracking-[0.18em] border border-line-strong rounded-full text-ink-muted hover:text-acid hover:border-acid"
        data-testid={`array-${k}-add`}
      >
        <Plus size={12} /> Añadir
      </button>
    </div>
  );
}
